import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = {
  class: "h-flex",
  style: { width: "calc(100% - 40px)" }
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwIcon = _resolveComponent("FwIcon")!
  const _component_FwFormInput = _resolveComponent("FwFormInput")!

  return (_openBlock(), _createBlock(_component_FwFormInput, {
    class: "h-mb-20",
    labelType: "label-thin",
    title: _ctx.title
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass([[option.class, { "b-add-edit__form__option-disabled": _ctx.optionsData[option.component].disabled || _ctx.disabled }], "h-flex h-flex-space-between h-flex-center h-pointer b-add-edit__form h-mv-20 h-pr-5"]),
          onClick: ($event: any) => (_ctx.showFeatureComponent(option))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_FwIcon, {
              class: "h-flex-center h-pointer h-ml-20",
              icon: option.icon,
              size: "20",
              color: _ctx.isValueExists(option.component) && !_ctx.optionsData[option.component].disabled && !_ctx.disabled ? "#203f6a" : "#BEC7D3"
            }, null, 8, ["icon", "color"]),
            _createElementVNode("p", {
              style: _normalizeStyle({
                   color: _ctx.isValueExists(option.component) && !_ctx.optionsData[option.component].disabled && !_ctx.disabled ? "#203f6a" : "#BEC7D3"
               }),
              class: "b-add-edit__form__option h-ml-20 h-text-overflow-ellipsis h-width-100p"
            }, _toDisplayString(_ctx.getTranslatedText(option.component)), 5)
          ]),
          _createVNode(_component_FwIcon, {
            class: "h-mh-5",
            icon: _ctx.optionsData[option.component].disabled || _ctx.disabled ? "lock" : "arrow-right",
            size: _ctx.optionsData[option.component].disabled || _ctx.disabled ? "20" : "10",
            color: "#BEC7D3"
          }, null, 8, ["icon", "size"])
        ], 10, _hoisted_1))
      }), 256))
    ]),
    _: 1
  }, 8, ["title"]))
}